export default __webpack_public_path__ + "static/media/vrt.5ea66db8.svg";